export default function formatTime(hours, minutes, seconds) {
  const pad = (number) => {
    return number.toString().padStart(2, '0')
  }

  return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
}
